const Urls = {
	type:{
		base:1,
		user:2
	},
	permission:{
		auth:'/auth',
		departmentAccount:'/department/accounts',
		schoolAccount:'/school/accounts'
	},
	edu:{
		projectAdd:'/appointment/add',
		projectList:'/appointment/list',
		projectDelete:'/appointment/delete',
		projectDetail:'/appointment/user/detail',
		confirmAdd:'/confirm/add',
		confirmList:'/confirm/list',
		confirmDelete:'/confirm/delete',
		confirmDetail:'/confirm/user/detail',
		confirmExport:'/confirm/user/export'
	},
	school:{
		login:'/login',
		regist:'/register',
		resetPwd:'/user/password/reset',
		userStatus:'/user/status',
		VerificationCode:'/verificationCode',

		projectList:'/user/appointment/list',
		projectKill:'/user/second/kill',
		projectKillResult:'/user/second/kill/result',
		orderDetail:'/user/order/detail',
		orderCancel:'/user/cancel/order',

		confirmList:'/user/confirm/list',
		confirmKill:'/user/confirm/kill',
		confirmOrderDetail:'/user/confirm/order/detail',
		confirmOrderCancel:'/user/confirm/cancel/order',
		
	}
}
export default Urls